import React from "react";
import {
  Table as ReactAriaTable,
  ResizableTableContainer,
  SortDescriptor as RACSortDescriptor,
} from "react-aria-components";
import clsx from "clsx";

import { TableContext } from "./table/table-context";
import styles from "./table.module.css";

export type SortDescriptor = RACSortDescriptor;

interface TableProps {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  "data-testid"?: string;
  "aria-label": string;
  sortDescriptor?: SortDescriptor;
  onSortChange?: (descriptor: SortDescriptor) => void;
  isResizable?: boolean;
  display?: {
    tableLayout?: "fixed" | "auto";
  };
}

function Table({
  style,
  className,
  children,
  "data-testid": testId,
  "aria-label": ariaLabel,
  onSortChange,
  sortDescriptor,
  display = { tableLayout: "auto" },
  isResizable = true,
}: TableProps) {
  const table = (
    <ReactAriaTable
      style={{ ...style, tableLayout: display.tableLayout }}
      sortDescriptor={sortDescriptor}
      onSortChange={onSortChange}
      className={clsx(styles.table, className)}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {children}
    </ReactAriaTable>
  );

  const wrapped = isResizable ? (
    <ResizableTableContainer className={styles.tableContainer}>
      {table}
    </ResizableTableContainer>
  ) : (
    table
  );

  return (
    <TableContext.Provider value={{ isResizable }}>
      {wrapped}
    </TableContext.Provider>
  );
}

export default Table;
